<template>
  <div class="map-list-wrapper">
    <Table
      ref="tableRef"
      :params="tableParams"
      :request="getData"
      tooltip-effect="light"
    >
      <template #search="{ query }">
        <el-form-item>
          <el-button icon="el-icon-plus" type="danger" @click="openCreateDialog">
            {{ $t('smartRouting.mapCenter.mapManagement.addMap') }}
          </el-button>
        </el-form-item>
      </template>

      <el-table-column
        prop="code"
        :label="$t('smartRouting.mapCenter.mapManagement.mapCode')"
        min-width="130"
      />
      <el-table-column
        prop="name"
        :label="$t('smartRouting.mapCenter.mapManagement.mapName')"
        min-width="140"
      />
      <el-table-column
        prop="source"
        :label="$t('smartRouting.mapCenter.mapManagement.source')"
        width="110"
      >
        <template #default="{ row }">
          {{ getSourceLabel(row.source) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="createBy"
        :label="$t('smartRouting.mapCenter.creator')"
        min-width="140"
      />
      <el-table-column
        prop="createTime"
        :label="$t('smartRouting.mapCenter.createdAt')"
        min-width="140"
      />
      <el-table-column
        prop="updateBy"
        :label="$t('smartRouting.mapCenter.updater')"
        min-width="140"
      />
      <el-table-column
        prop="updateTime"
        :label="$t('smartRouting.mapCenter.updatedAt')"
        min-width="140"
      />
      <el-table-column
        :label="$t('smartRouting.mapCenter.mapManagement.operation')"
        width="130"
        fixed="right"
      >
        <template #default="{ row }">
          <el-tooltip :content="$t('smartRouting.mapCenter.detail')" placement="top">
            <el-button
              type="text"
              size="small"
              icon="el-icon-view"
              @click="openDetailDialog(row)"
            >
              <!-- {{ $t('smartRouting.mapCenter.detail') }} -->
            </el-button>
          </el-tooltip>
          <el-tooltip :content="$t('smartRouting.mapCenter.edit')" placement="top">
            <el-button
              type="text"
              size="small"
              icon="el-icon-edit"
              @click="handleEdit(row)"
            >
              <!-- {{ $t('smartRouting.mapCenter.edit') }} -->
            </el-button>
          </el-tooltip>
          <!-- <el-tooltip :content="$t('smartRouting.mapCenter.edit')" placement="top">
            <el-button
              type="text"
              size="small"
              icon="el-icon-location-outline"
              @click="handleAnnotation(row)"
            >
              
            </el-button>
          </el-tooltip> -->
          <el-tooltip :content="$t('smartRouting.mapCenter.delete')" placement="top">
            <el-button
              type="text"
              style="color: red"
              size="small"
              icon="el-icon-delete"
              @click="handleDelete(row)"
            >
              <!-- {{ $t('smartRouting.mapCenter.delete') }} -->
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </Table>

    <!-- ========== 新建/编辑地图弹窗 ========== -->
    <el-dialog
      v-model="createDialogVisible"
      :title="isEditMode ? $t('smartRouting.mapCenter.mapManagement.mapCreate.mapEdit',{name: detailData.name}) : $t('smartRouting.mapCenter.mapManagement.mapCreate.title')"
      width="1024px"
      :close-on-click-modal="false"
      @close="handleCreateDialogClose"
    >
      <el-form
        ref="createFormRef"
        :model="createFormData"
        :rules="createFormRules"
        label-width="120px"
        label-position="right"
        class="dialog-form"
      >
        <el-form-item
          :label="$t('smartRouting.mapCenter.mapManagement.mapCreate.mapName')"
          prop="name"
          required
        >
          <el-input
            v-model="createFormData.name"
            :placeholder="
              $t(
                'smartRouting.mapCenter.mapManagement.mapCreate.mapNamePlaceholder'
              )
            "
            maxlength="50"
          />
        </el-form-item>

        <el-form-item
          :label="$t('smartRouting.mapCenter.mapManagement.mapCreate.address')"
          prop="address"
          required
        >
          <el-input
            v-model="createFormData.address"
            :placeholder="
              $t(
                'smartRouting.mapCenter.mapManagement.mapCreate.addressPlaceholder'
              )
            "
            maxlength="100"
          />
        </el-form-item>

        <el-form-item
          :label="
            $t('smartRouting.mapCenter.mapManagement.mapCreate.mappingRobots')
          "
          prop="createMapRobot"
        >
          <el-select
            v-model="createFormData.createMapRobot"
            :placeholder="
              $t('smartRouting.mapCenter.mapManagement.mapCreate.mappingRobots')
            "
            style="width: 100%"
          >
            <el-option
              v-for="item in deviceList"
              :key="item.deviceCode"
              :label="item.deviceName || '--'"
              :value="item.deviceCode"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          :label="
            $t('smartRouting.mapCenter.mapManagement.mapCreate.mapDataPackage')
          "
          prop="resourcePackagePath"
          required
        >
          <el-upload
            :file-list="fileList"
            action="#"
            :auto-upload="false"
            name="image"
            :on-change="onImageChange"
            :on-remove="onImageRemove"
            :on-preview="onImagePreview"
          >
            <el-button size="small" type="primary">{{
              $t('smartRouting.mapCenter.clickToUpload')
            }}</el-button>
            <template #tip>
              <div class="el-upload__tip">
                {{
                  $t(
                    'smartRouting.mapCenter.mapManagement.mapCreate.fileUploadHint'
                  )
                }}
              </div>
            </template>
          </el-upload>
        </el-form-item>

        <el-form-item
          :label="
            $t('smartRouting.mapCenter.mapManagement.mapCreate.mapImage')
          "
          prop="mapImagePath"
          required
        >
          <el-upload
            :file-list="fileList1"
            action="#"
            :auto-upload="false"
            name="image"
            :on-change="onMapImagePathChange"
            :on-remove="onImageRemove1"
            :on-preview="onImagePreview"
          >
            <el-button size="small" type="primary">{{
              $t('smartRouting.mapCenter.clickToUpload')
            }}</el-button>
            <template #tip>
              <div class="el-upload__tip">
                {{
                  $t(
                    'smartRouting.mapCenter.mapManagement.mapCreate.fileUploadHint1'
                  )
                }}
              </div>
            </template>
          </el-upload>
        </el-form-item>

        <el-form-item
          :label="
            $t('smartRouting.mapCenter.mapManagement.mapCreate.mapParameters')
          "
          prop="mapParametersPath"
        >
          <el-upload
            :file-list="fileList2"
            action="#"
            :auto-upload="false"
            name="image"
            :on-change="onMapParametersPathChange"
            :on-remove="onImageRemove2"
            :on-preview="onImagePreview"
          >
            <el-button size="small" type="primary">{{
              $t('smartRouting.mapCenter.clickToUpload')
            }}</el-button>
            <template #tip>
              <div class="el-upload__tip">
                {{
                  $t(
                    'smartRouting.mapCenter.mapManagement.mapCreate.fileUploadHint2'
                  )
                }}
              </div>
            </template>
          </el-upload>

          <!-- 解析中 -->
          <div v-if="parseLoading" class="yaml-parse-tip yaml-parse-tip--loading">
            {{ $t('smartRouting.mapCenter.mapManagement.mapCreate.yamlParsing') }}
          </div>

          <!-- 解析失败 -->
          <div v-else-if="parseError" class="yaml-parse-tip yaml-parse-tip--error">
            {{ $t('smartRouting.mapCenter.mapManagement.mapCreate.yamlParseFailed', { error: parseError }) }}
          </div>

          <!-- 解析成功提示 -->
          <div v-else-if="mapParseYaml" class="yaml-parse-tip yaml-parse-tip--success">
            {{ $t('smartRouting.mapCenter.mapManagement.mapCreate.yamlParseSuccess') }}
          </div>

          <!-- ========== 参数卡片 ========== -->
          <div v-if="mapParseYaml" class="yaml-card">
            <!-- 顶部：文件名 + 状态 -->
            <div class="yaml-card__header">
              <span class="yaml-card__file">{{ parsedFileName }}</span>
              <span class="yaml-card__badge">{{ $t('smartRouting.mapCenter.mapManagement.mapCreate.yamlParseBadge') }}</span>
            </div>

            <!-- 参数网格 -->
            <div class="yaml-card__grid">
              <div
                v-for="(val, key) in mapParseYaml"
                :key="key"
                class="yaml-item"
              >
                <span class="yaml-item__label">{{ key }}</span>
                <span
                  class="yaml-item__value"
                  :class="{ 'is-array': Array.isArray(val) }"
                  :title="formatValue(val)"
                >
                  {{ formatValue(val) }}
                </span>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item
          :label="$t('smartRouting.mapCenter.mapManagement.mapCreate.remark')"
          prop="note"
        >
          <el-input
            v-model="createFormData.note"
            :placeholder="
              $t(
                'smartRouting.mapCenter.mapManagement.mapCreate.remarkPlaceholder'
              )
            "
            type="textarea"
            :rows="2"
            maxlength="200"
          />
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="handleCreateDialogClose">
          {{ $t('smartRouting.mapCenter.mapManagement.mapCreate.cancel') }}
        </el-button>
        <el-button
          type="primary"
          :loading="createSubmitting"
          @click="handleCreateSubmit"
        >
          {{ isEditMode ? $t('smartRouting.mapCenter.mapManagement.mapCreate.save') : $t('smartRouting.mapCenter.mapManagement.mapCreate.create') }}
        </el-button>
      </template>
    </el-dialog>

    <!-- ========== 地图详情弹窗 ========== -->
    <el-dialog
      v-model="detailDialogVisible"
      :title="$t('smartRouting.mapCenter.mapManagement.mapDetail.title', { name: detailData.name || '' })"
      width="960px"
      :close-on-click-modal="false"
      class="map-detail-dialog"
      @close="handleDetailDialogClose"
    >
      <div class="detail-container">
        <el-row :gutter="24" class="detail-row">
          <!-- 左栏 - 地图图片 -->
          <el-col :span="14" class="detail-left">
            <div class="detail-map-preview">
              <el-image
                v-if="detailData.mapImageUrl"
                :src="detailData.mapImageUrl"
                fit="contain"
                class="map-image"
              />
              <div v-else class="map-placeholder">
                <span>{{ $t('smartRouting.mapCenter.mapManagement.mapDetail.noMapImage') }}</span>
              </div>
            </div>
          </el-col>

          <!-- 右栏 - 详情信息 -->
          <el-col :span="10" class="detail-right">
            <el-descriptions :column="1" border class="detail-descriptions">
              <el-descriptions-item :label="$t('smartRouting.mapCenter.mapManagement.mapName')" label-align="right">
                <span class="field-value">{{ detailData.name || '-' }}</span>
              </el-descriptions-item>
              <el-descriptions-item :label="$t('smartRouting.mapCenter.mapManagement.mapCode')" label-align="right">
                <span class="field-value">{{ detailData.code || '-' }}</span>
              </el-descriptions-item>
              <el-descriptions-item :label="$t('smartRouting.mapCenter.mapManagement.source')" label-align="right">
                <span class="field-value">{{ getSourceLabel(detailData.source) }}</span>
              </el-descriptions-item>
              <el-descriptions-item :label="$t('smartRouting.mapCenter.mapManagement.mapDetail.coordinateParams')" label-align="right">
                <span class="field-value">{{ detailData.coordinateParams || '-' }}</span>
              </el-descriptions-item>
              <el-descriptions-item :label="$t('smartRouting.mapCenter.mapManagement.mapCreate.mappingRobots')" label-align="right">
                <span class="field-value">{{ detailData.createMapRobot || '-' }}</span>
              </el-descriptions-item>
              <el-descriptions-item :label="$t('smartRouting.mapCenter.mapManagement.mapCreate.address')" label-align="right">
                <span class="field-value">{{ detailData.address || '-' }}</span>
              </el-descriptions-item>
              <el-descriptions-item :label="$t('smartRouting.mapCenter.mapManagement.mapDetail.deployedCoverage')" label-align="right">
                <span class="field-value">{{ detailData.deployedCoverage || $t('smartRouting.mapCenter.mapManagement.mapDetail.unDeployed') }}</span>
              </el-descriptions-item>
              <el-descriptions-item :label="$t('smartRouting.mapCenter.mapManagement.mapDetail.sourceFile')" label-align="right">
                <span class="field-value source-file">
                  {{ detailData.resourcePackagePath || '-' }}
                </span>
              </el-descriptions-item>
              <el-descriptions-item :label="$t('smartRouting.mapCenter.mapManagement.mapCreate.mapImage')" label-align="right">
                <span class="field-value">{{ detailData.mapImagePath || '-' }}</span>
              </el-descriptions-item>
              <el-descriptions-item :label="$t('smartRouting.mapCenter.mapManagement.mapCreate.remark')" label-align="right">
                <span class="field-value remark-value">{{ detailData.note || $t('smartRouting.mapCenter.mapManagement.mapDetail.noNote') }}</span>
              </el-descriptions-item>
            </el-descriptions>
          </el-col>
        </el-row>
      </div>

      <template #footer>
        <el-button @click="handleDetailDialogClose">{{ $t('smartRouting.mapCenter.mapManagement.mapDetail.close') }}</el-button>
      </template>
    </el-dialog>

    <!-- 区域标注组件 -->
    <AreaAnnotation
      v-model="areaAnnotationVisible"
      :mapInfo="mapRow"
      @success="handleSuccess"
    />
  </div>
</template>

<script>
import { reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElMessage, ElMessageBox } from 'element-plus'
import Table from '@/components/elp/table'
import AreaAnnotation from "./areaAnnotation.vue";
import {
  reqMapPage,
  reqMapDetail,
  reqMapCreate,
  reqMapUpdate,
  reqMapDelete,
  reqDeviceList,
  reqMapParseYaml
} from '@/api/map'
import { ossUpload } from '@/utils/oss'

export default {
  name: 'MapList',
  components: {
    Table,
    AreaAnnotation
  },
  props: {
    request: {
      type: Function,
      required: true
    }
  },
  emits: ['add-map', 'view-detail'],
  setup(props, { emit }) {
    const { t } = useI18n()
    const tableRef = ref(null)

    // ========== Table 参数 ==========
    const tableParams = reactive([
      {
        key: 'mapCode',
        value: '',
        label: t('smartRouting.mapCenter.mapManagement.mapCode'),
        type: 'input',
        clearable: true
      },
      {
        key: 'mapName',
        value: '',
        label: t('smartRouting.mapCenter.mapManagement.mapName'),
        type: 'input',
        clearable: true
      }
    ])

    const deviceList = ref([])

    // ========== 标签转换方法 ==========
    const getSourceLabel = key => {
      const map = {
        cadImport: t('smartRouting.mapCenter.mapManagement.sourceOptions.cadImport'),
        slamMapping: t('smartRouting.mapCenter.mapManagement.sourceOptions.slamMapping'),
        handSketch: t('smartRouting.mapCenter.mapManagement.sourceOptions.handSketch')
      }
      return map[key] || key || '-'
    }

    const getStatusLabel = key => {
      const map = {
        published: t('smartRouting.mapCenter.mapManagement.statusOptions.published'),
        draft: t('smartRouting.mapCenter.mapManagement.statusOptions.draft'),
        pendingSync: t('smartRouting.mapCenter.mapManagement.statusOptions.pendingSync')
      }
      return map[key] || key || '-'
    }

    const getStatusType = key => {
      const map = {
        published: 'success',
        draft: 'info',
        pendingSync: 'warning'
      }
      return map[key] || ''
    }

    // ============================================================
    // ========== 2. 地图详情 ==========
    // ============================================================
    const detailDialogVisible = ref(false)
    const detailData = reactive({
      id: '',
      name: '',
      code: '',
      source: '',
      coordinateParams: '',
      createMapRobot: '',
      address: '',
      annotationPoints: 0,
      forbiddenZoneCount: 0,
      version: '',
      status: '',
      deployedCoverage: '',
      resourcePackagePath: '',
      sourceFileType: '',
      mapImagePath: '',
      note: '',
      mapImageUrl: '',
      resolution: 0.05,
      originX: -14.3,
      originY: -5.68,
      yFlip: true
    })

    const openDetailDialog = async row => {
      try {
        const res = await reqMapDetail(row.id)
        const data = res.data || res
        detailData.id = data.id || row.id
        detailData.name = data.name || row.name
        detailData.code = data.code || row.code
        detailData.source = data.source || row.source

        detailData.resolution = data.resolution
        detailData.originX = data.origin?.[0] || data.originX || -14.3
        detailData.originY = data.origin?.[1] || data.originY || -5.68
        detailData.yFlip = data.yFlip !== undefined ? data.yFlip : true

        detailData.coordinateParams =
          `res ${detailData.resolution} m/px · 原点(${detailData.originX}, ${detailData.originY}) · Y${detailData.yFlip ? '翻转' : '正向'}`
        detailData.createMapRobot = data.createMapRobot || '-'
        detailData.address = data.address || '-'
        detailData.annotationPoints = data.annotationPoints || 0
        detailData.forbiddenZoneCount = data.forbiddenZoneCount || 0
        detailData.version = data.version || row.version || 'v1.0'
        detailData.status = data.status || row.status || 'draft'
        detailData.deployedCoverage = data.deployedCoverage || '未部署'
        detailData.resourcePackagePath = data.resourcePackagePath || '-'
        detailData.sourceFileType = data.sourceFileType || ''
        detailData.mapImagePath = data.mapImagePath
        detailData.note = data.note || ''
        detailData.mapImageUrl = data.mapImageUrl || data.mapImagePath || ''

        detailDialogVisible.value = true
      } catch (error) {
        console.error('获取地图详情失败:', error)
        ElMessage.error(t('smartRouting.mapCenter.mapManagement.mapDetail.getDetailFailed'))
      }
    }

    const handleDetailDialogClose = () => {
      detailDialogVisible.value = false
    }

    const handleEditMap = () => {
      const row = {
        id: detailData.id,
        name: detailData.name,
        code: detailData.code
      }
      detailDialogVisible.value = false
      handleEdit(row)
    }

    const handleEditAnnotation = () => {
      ElMessage.info(t('smartRouting.mapCenter.mapManagement.mapDetail.editAnnotationDeveloping'))
    }

    // ============================================================
    // ========== 3. 新建/编辑地图 ==========
    // ============================================================
    const createDialogVisible = ref(false)
    const areaAnnotationVisible = ref(false)
    const createFormRef = ref(null)
    const uploadRef = ref(null)
    const createSubmitting = ref(false)
    const isEditMode = ref(false)
    const editId = ref(null)
    const fileList = ref([])
    const fileList1 = ref([])
    const fileList2 = ref([])
    const uploadUrl = ref('/api/map/upload')

    // ===== 解析结果相关 =====
    const mapParseYaml = ref(null)
    const parsedFileName = ref('')
    const parseLoading = ref(false)
    const parseError = ref('')

    const createFormData = reactive({
      name: '',
      address: '',
      source: 'slamMapping',
      createMapRobot: '',
      resourcePackagePath: '',
      mapImagePath: '',
      mapParametersPath: '',
      resolution: 0.05,
      originX: -14.3,
      originY: -5.68,
      yFlip: true,
      note: ''
    })

    const createFormRules = {
      name: [
        {
          required: true,
          message: t('smartRouting.mapCenter.mapManagement.mapCreate.mapNamePlaceholder'),
          trigger: 'blur'
        }
      ],
      address: [
        {
          required: true,
          message: t('smartRouting.mapCenter.mapManagement.mapCreate.address'),
          trigger: 'blur'
        }
      ],
      resourcePackagePath: [
        {
          required: true,
          message: t('smartRouting.mapCenter.mapManagement.mapCreate.mapDataPackage'),
          trigger: 'change'
        }
      ],
      mapImagePath: [
        {
          required: true,
          message: t('smartRouting.mapCenter.mapManagement.mapCreate.mapImage'),
          trigger: 'change'
        }
      ]
    }

    const openCreateDialog = () => {
      isEditMode.value = false
      editId.value = null
      resetCreateForm()
      createDialogVisible.value = true
    }

    const resetCreateForm = () => {
      createFormData.name = ''
      createFormData.address = ''
      createFormData.source = 'slamMapping'
      createFormData.createMapRobot = ''
      createFormData.resourcePackagePath = ''
      createFormData.mapImagePath = ''
      createFormData.mapParametersPath = ''
      createFormData.resolution = 0.05
      createFormData.originX = -14.3
      createFormData.originY = -5.68
      createFormData.yFlip = true
      createFormData.note = ''
      fileList.value = []
      fileList1.value = []
      fileList2.value = []
      mapParseYaml.value = null
      parsedFileName.value = ''
      parseError.value = ''
      parseLoading.value = false
      createFormRef.value?.resetFields()
    }

    const handleCreateDialogClose = () => {
      createDialogVisible.value = false
      resetCreateForm()
      isEditMode.value = false
      editId.value = null
    }

    const onImageChange = async file => {
      fileList.value = [file]
      try {
        if (!file.raw) return
        await ossUpload(file.raw.name, file.raw, {
          path: 'ota/ic/map',
          timestamp: false
        })
        createFormData.resourcePackagePath = `ota/ic/map/${file.raw.name}` || ''
      } catch (error) {
        console.error(error)
      }
    }

    const onMapImagePathChange = async file => {
      fileList1.value = [file]
      try {
        if (!file.raw) return
        await ossUpload(file.raw.name, file.raw, {
          path: 'ota/ic/map',
          timestamp: false
        })
        createFormData.mapImagePath = `ota/ic/map/${file.raw.name}` || ''
      } catch (error) {
        console.error(error)
      }
    }

    // ========== 参数文件上传 → 触发解析 ==========
    const onMapParametersPathChange = async file => {
      fileList2.value = [file]
      try {
        if (!file.raw) return
        await ossUpload(file.raw.name, file.raw, {
          path: 'ota/ic/map',
          timestamp: false
        })
        createFormData.mapParametersPath = `ota/ic/map/${file.raw.name}` || ''
        await getMapParseYaml(createFormData.mapParametersPath)
      } catch (error) {
        console.error('上传地图参数失败:', error)
        ElMessage.error(t('smartRouting.mapCenter.mapManagement.mapCreate.uploadFailed'))
      }
    }

    // ========== 解析 YAML ==========
    const getMapParseYaml = async (ossPath, options = {}) => {
      const { silent = false } = options
      if (!ossPath) return
      parseLoading.value = true
      parseError.value = ''
      mapParseYaml.value = null
      try {
        const res = await reqMapParseYaml({ ossPath })

        // 真实返回结构：res.entries 是扁平对象
        const entries = res?.entries || {}
        parsedFileName.value = ossPath.split('/').pop() || ''
        mapParseYaml.value = entries

        // ===== 回填表单 =====
        if (entries.resolution !== undefined && entries.resolution !== null) {
          createFormData.resolution = Number(entries.resolution)
        }
        const ox = entries.originX ?? entries.origin?.[0]
        const oy = entries.originY ?? entries.origin?.[1]
        if (ox !== undefined && ox !== null) createFormData.originX = Number(ox)
        if (oy !== undefined && oy !== null) createFormData.originY = Number(oy)
        if (entries.negate !== undefined && entries.negate !== null) {
          createFormData.yFlip = Number(entries.negate) === 1
        }

        if (!silent) {
          ElMessage.success(t('smartRouting.mapCenter.mapManagement.mapCreate.parseSuccess'))
        }
      } catch (error) {
        console.error('解析地图参数失败:', error)
        parseError.value = error?.message || t('smartRouting.mapCenter.mapManagement.mapCreate.parseFailed')
        if (!silent) {
          ElMessage.error(t('smartRouting.mapCenter.mapManagement.mapCreate.parseYamlFailed'))
        }
      } finally {
        parseLoading.value = false
      }
    }

    // ========== 值格式化：数组、字符串、数字统一展示 ==========
    const formatValue = (val) => {
      if (val === null || val === undefined) return '-'
      if (Array.isArray(val)) return `[${val.join(', ')}]`
      if (typeof val === 'object') return JSON.stringify(val)
      return String(val)
    }

    const onImageRemove = () => {
      fileList.value = []
      createFormData.resourcePackagePath = ''
    }

    const onImageRemove1 = () => {
      fileList1.value = []
      createFormData.mapImagePath = ''
    }

    const onImageRemove2 = () => {
      fileList2.value = []
      createFormData.mapParametersPath = ''
      mapParseYaml.value = null
      parsedFileName.value = ''
      parseError.value = ''
      parseLoading.value = false
    }

    const onImagePreview = item => {
      console.log('onImagePreview', item)
    }

    const beforeUpload = file => {
      const isValidType = /\.(pcd|bag|las|pgm|yaml|zip)$/i.test(file.name)
      if (!isValidType) {
        ElMessage.error(t('smartRouting.mapCenter.mapManagement.mapCreate.fileTypeNotSupported'))
        return false
      }
      const isLt100M = file.size / 1024 / 1024 < 100
      if (!isLt100M) {
        ElMessage.error(t('smartRouting.mapCenter.mapManagement.mapCreate.fileSizeExceeded'))
        return false
      }
      return true
    }

    const handleUploadSuccess = (response, file) => {
      if (response.code === 0) {
        createFormData.resourcePackagePath =
          response.data?.fileId || response.data?.url || file.name
        if (response.data?.resolution)
          createFormData.resolution = response.data.resolution
        if (response.data?.originX !== undefined)
          createFormData.originX = response.data.originX
        if (response.data?.originY !== undefined)
          createFormData.originY = response.data.originY
        ElMessage.success(t('smartRouting.mapCenter.mapManagement.mapCreate.uploadSuccess'))
      } else {
        ElMessage.error(response.message || t('smartRouting.mapCenter.mapManagement.mapCreate.uploadFailed'))
      }
    }

    const handleUploadError = () => {
      ElMessage.error(t('smartRouting.mapCenter.mapManagement.mapCreate.uploadFailed'))
    }

    const handleRemove = () => {
      createFormData.resourcePackagePath = ''
    }

    // ===== 编辑地图 =====
    const handleEdit = async row => {
      try {
        isEditMode.value = true
        editId.value = row.id
        detailData.name = row.name
        const res = await reqMapDetail(row.id)
        const data = res.data || res
        createFormData.name = data.name || row.name || ''
        createFormData.address = data.address || ''
        createFormData.source = data.source || 'slamMapping'
        createFormData.createMapRobot = data.createMapRobot || ''
        createFormData.resourcePackagePath = data.resourcePackagePath || ''
        createFormData.mapImagePath = data.mapImagePath || data.mapImageUrl || ''
        createFormData.mapParametersPath = data.mapParametersPath || ''
        createFormData.resolution = data.resolution
        createFormData.originX = data.origin?.[0] || data.originX || -14.3
        createFormData.originY = data.origin?.[1] || data.originY || -5.68
        createFormData.yFlip = data.yFlip !== undefined ? data.yFlip : true
        createFormData.note = data.note 
        if (createFormData.resourcePackagePath) {
          const fileName = createFormData.resourcePackagePath.split('/').pop()
          fileList.value = [{ name: fileName, url: createFormData.resourcePackagePath }]
        }
        if (createFormData.mapImagePath) {
          const fileName = createFormData.mapImagePath.split('/').pop()
          fileList1.value = [{ name: fileName, url: createFormData.mapImagePath }]
        }
        if (createFormData.mapParametersPath) {
          const fileName = createFormData.mapParametersPath.split('/').pop()
          fileList2.value = [{ name: fileName, url: createFormData.mapParametersPath }]
          // 编辑时静默解析
          getMapParseYaml(createFormData.mapParametersPath, { silent: true })
        }

        createDialogVisible.value = true
      } catch (error) {
        console.error('获取地图详情失败:', error)
        ElMessage.error(t('smartRouting.mapCenter.mapManagement.mapDetail.getDetailFailed'))
      }
    }

    // ===== 区域标注 =====
    const mapRow = ref({})
    const handleAnnotation = async row =>  {
      try {
        const res = await reqMapDetail(row.id)
        const data = res.data || res
        mapRow.value = data

        areaAnnotationVisible.value = true
      } catch (error) {
        console.error('获取地图详情失败:', error)
        ElMessage.error(t('smartRouting.mapCenter.mapManagement.mapDetail.getDetailFailed'))
      }
    }

    // 区域标注保存成功的回调
    const handleSuccess = (annotations) => {
      console.log('成功获取到地图标注数据:', annotations)
      ElMessage.success('区域标注保存成功')
      
      // 关闭弹窗
      areaAnnotationVisible.value = false
      
      // 如果有调用后端接口保存数据的逻辑，可以写在这里：
      // await reqSaveAnnotation({ mapId: mapRow.value.id, annotations })
      
      // 刷新表格（如果列表需要展示标注数量等）
      // tableRef.value?.search()
    }

    // 创建/更新地图
    const handleCreateSubmit = async () => {
      try {
        await createFormRef.value?.validate()
      } catch {
        return
      }

      createSubmitting.value = true
      try {
        const params = {
          name: createFormData.name,
          address: createFormData.address,
          source: createFormData.source,
          createMapRobot: createFormData.createMapRobot,
          resourcePackagePath: createFormData.resourcePackagePath,
          mapImagePath: createFormData.mapImagePath,
          mapParametersPath: createFormData.mapParametersPath,
          resolution: createFormData.resolution,
          originX: createFormData.originX,
          originY: createFormData.originY,
          yFlip: createFormData.yFlip,
          note: createFormData.note,
          code: editId.value
        }

        let res
        if (isEditMode.value) {
          res = await reqMapUpdate(params)
        } else {
          res = await reqMapCreate(params)
        }

        createDialogVisible.value = false
        resetCreateForm()
        isEditMode.value = false
        editId.value = null
        tableRef.value?.search()
      } catch (error) {
        console.error(isEditMode.value ? '更新地图失败:' : '创建地图失败:', error)
        ElMessage.error(isEditMode.value ? t('smartRouting.mapCenter.mapManagement.mapCreate.updateFailed') : t('smartRouting.mapCenter.mapManagement.mapCreate.createFailed'))
      } finally {
        createSubmitting.value = false
      }
    }

    // ============================================================
    // ========== 4. 删除地图 ==========
    // ============================================================
    const handleDelete = async row => {
      try {
        await ElMessageBox.confirm(
          t('smartRouting.mapCenter.mapManagement.deleteConfirm', { name: row.name || row.code }),
          t('smartRouting.mapCenter.mapManagement.deleteTitle'),
          {
            confirmButtonText: t('smartRouting.mapCenter.mapManagement.confirm'),
            cancelButtonText: t('smartRouting.mapCenter.mapManagement.cancel'),
            type: 'warning'
          }
        )
        await reqMapDelete(row.id)
        ElMessage.success(t('smartRouting.mapCenter.mapManagement.deleteSuccess'))
        tableRef.value?.search()
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除地图失败:', error)
          ElMessage.error(t('smartRouting.mapCenter.mapManagement.deleteFailed'))
        }
      }
    }

    const getData = async (params) => {
      const query = {
        pageNum: params.page,
        pageSize: params.size
      }
      if (params.dateRange?.length) {
        query.startDate = params.dateRange[0]
        query.endDate = params.dateRange[1]
      } else {
        query.startDate = undefined
        query.endDate = undefined
      }

      return await reqMapPage(Object.assign(query, params))
    }

    const getDeviceList = async () => {
      try {
        const res = await reqDeviceList({})
        deviceList.value = res
      } catch (error) {
        console.error('获取设备列表失败:', error)
      }
    }

    getDeviceList()

    return {
      tableRef,
      tableParams,
      getSourceLabel,
      getStatusLabel,
      getStatusType,
      // 新建/编辑地图
      createDialogVisible,
      areaAnnotationVisible,
      createFormRef,
      uploadRef,
      createFormData,
      createFormRules,
      mapRow,
      fileList,
      fileList1,
      fileList2,
      uploadUrl,
      createSubmitting,
      isEditMode,
      openCreateDialog,
      handleCreateDialogClose,
      beforeUpload,
      handleUploadSuccess,
      handleUploadError,
      handleRemove,
      handleCreateSubmit,
      handleEdit,
      // 地图详情
      detailDialogVisible,
      detailData,
      openDetailDialog,
      handleDetailDialogClose,
      handleEditMap,
      handleEditAnnotation,
      // 删除
      handleDelete,
      getData,
      onImageChange,
      onMapImagePathChange,
      onMapParametersPathChange,
      onImageRemove,
      onImageRemove1,
      onImageRemove2,
      onImagePreview,
      deviceList,
      // 解析
      mapParseYaml,
      parsedFileName,
      parseLoading,
      parseError,
      getMapParseYaml,
      formatValue,
      handleAnnotation,
      handleSuccess
    }
  }
}
</script>

<style scoped>
.map-list-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* ========== 新建地图弹窗样式 ========== */
.form-path {
  font-size: 14px;
  color: #909399;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebeef5;
}

.form-hint {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.coordinate-params {
  width: 100%;
}
.coordinate-hint {
  font-size: 12px;
  color: #909399;
  margin-bottom: 12px;
}
.coordinate-params :deep(.el-form-item) {
  margin-bottom: 8px;
}

.switch-hint {
  margin-left: 12px;
  font-size: 13px;
  color: #606266;
}

:deep(.el-upload__tip) {
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
}

:deep(.el-dialog__body) {
  max-height: 65vh;
  overflow-y: auto;
}

/* ========== YAML 解析提示 ========== */
.yaml-parse-tip {
  font-size: 12px;
  line-height: 18px;
  margin-top: 4px;
}
.yaml-parse-tip--loading { color: #409eff; }
.yaml-parse-tip--error   { color: #f56c6c; }
.yaml-parse-tip--success { color: #52c41a; }

/* ========== 参数卡片 ========== */
.yaml-card {
  margin-top: 8px;
  padding: 10px 14px;
  background: #f7f8fa;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.5;
}

/* --- 顶部 --- */
.yaml-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 8px;
  margin-bottom: 8px;
  border-bottom: 1px dashed #e5e6eb;
}

.yaml-card__file {
  font-size: 12px;
  font-weight: 500;
  color: #1d2129;
  font-family: 'SF Mono', Menlo, Consolas, monospace;
  word-break: break-all;
}

.yaml-card__badge {
  display: inline-flex;
  align-items: center;
  height: 18px;
  padding: 0 6px;
  font-size: 11px;
  line-height: 1;
  color: #52c41a;
  background: #f0f9eb;
  border: 1px solid #d9f0c0;
  border-radius: 9px;
  flex-shrink: 0;
}

/* --- 参数网格：3 列紧凑 --- */
.yaml-card__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px 16px;
}

/* --- 单项 --- */
.yaml-item {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  padding: 2px 0;
}

.yaml-item__label {
  flex-shrink: 0;
  /* width: 84px; */
  color: #86909c;
  font-size: 12px;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.yaml-item__value {
  flex: 1;
  min-width: 0;
  color: #1d2129;
  font-size: 12px;
  font-weight: 500;
  font-family: 'SF Mono', Menlo, Consolas, monospace;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 数组值：胶囊高亮 */
.yaml-item__value.is-array {
  display: inline-block;
  padding: 0 6px;
  background: #eef4ff;
  border-radius: 3px;
  color: #245bdb;
  line-height: 18px;
  max-width: 100%;
}

/* ========== 地图详情弹窗样式 ========== */
.map-detail-dialog :deep(.el-dialog) {
  border-radius: 12px;
}

.map-detail-dialog :deep(.el-dialog__header) {
  border-bottom: 1px solid #ebeef5;
  padding: 18px 24px;
}

.map-detail-dialog :deep(.el-dialog__title) {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.map-detail-dialog :deep(.el-dialog__body) {
  padding: 20px 24px;
}

.map-detail-dialog :deep(.el-dialog__footer) {
  border-top: 1px solid #ebeef5;
  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.detail-container {
  padding: 0;
}

.detail-row {
  display: flex;
  flex-wrap: wrap;
}

.detail-left {
  display: flex;
  flex-direction: column;
  padding-right: 12px;
}

.detail-map-preview {
  min-height: 320px;
  overflow: hidden;
}

.map-image {
  width: 100%;
  max-height: 360px;
}

.map-image :deep(.el-image__inner) {
  width: 100%;
  max-height: 360px;
  object-fit: contain;
}

.map-placeholder {
  color: #c0c4cc;
  font-size: 14px;
}

.detail-right {
  padding-left: 12px;
}

.detail-descriptions {
  width: 100%;
}

.detail-descriptions :deep(.el-descriptions__label) {
  width: 90px;
  font-weight: 500;
  color: #606266;
  background-color: #fafafa;
  padding: 8px 12px;
  font-size: 13px;
  white-space: nowrap;
}

.detail-descriptions :deep(.el-descriptions__content) {
  padding: 8px 12px;
  font-size: 13px;
  color: #303133;
}

.detail-descriptions :deep(.el-descriptions__body) {
  width: 100%;
}

.field-value {
  color: #303133;
  word-break: break-word;
}

.source-file {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.file-type {
  color: #909399;
  font-size: 12px;
}

.remark-value {
  color: #606266;
  line-height: 1.6;
}

/* ========== 响应式 ========== */
@media (max-width: 768px) {
  .detail-left {
    padding-right: 0;
    margin-bottom: 16px;
  }
  .detail-right {
    padding-left: 0;
    border-top: 1px solid #ebeef5;
    padding-top: 16px;
  }
  .detail-map-preview {
    min-height: 200px;
  }
  .map-image {
    max-height: 250px;
  }
  .map-image :deep(.el-image__inner) {
    max-height: 250px;
  }
  .yaml-card__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 480px) {
  .detail-map-preview {
    min-height: 150px;
  }
  .map-image {
    max-height: 180px;
  }
  .map-image :deep(.el-image__inner) {
    max-height: 180px;
  }
  .yaml-card__grid {
    grid-template-columns: 1fr;
  }
}
</style>